import { useState, useEffect, useRef, useCallback } from 'react';
import SinapiService from '../services/SinapiService';

export default function useSinapiSearch(tipo = 'composicoes') {
  const [query, setQuery] = useState('');
  const [estado, setEstado] = useState('SP');
  const [grupo, setGrupo] = useState('');
  const [tipoPreco, setTipoPreco] = useState('NAO_DESONERADO');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, total: 0, totalPages: 0 });
  const debounceRef = useRef(null);

  const fetchResults = useCallback(async (searchQuery, searchEstado, searchGrupo, searchTipoPreco, page) => {
    setLoading(true);
    try {
      let response;
      if (tipo === 'composicoes') {
        response = await SinapiService.searchComposicoes({
          query: searchQuery,
          estado: searchEstado,
          grupo: searchGrupo,
          tipoPreco: searchTipoPreco,
          page,
        });
      } else {
        response = await SinapiService.searchInsumos({
          query: searchQuery,
          estado: searchEstado,
          tipoPreco: searchTipoPreco,
          page,
        });
      }
      setResults(response.data || []);
      setPagination(response.pagination || { page: 1, total: 0, totalPages: 0 });
    } catch (err) {
      console.error('Erro na busca SINAPI:', err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  }, [tipo]);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchResults(query, estado, grupo, tipoPreco, 1);
    }, 300);
    return () => clearTimeout(debounceRef.current);
  }, [query, estado, grupo, tipoPreco, fetchResults]);

  const goToPage = useCallback((page) => {
    fetchResults(query, estado, grupo, tipoPreco, page);
  }, [query, estado, grupo, tipoPreco, fetchResults]);

  return {
    query, setQuery,
    estado, setEstado,
    grupo, setGrupo,
    tipoPreco, setTipoPreco,
    results,
    loading,
    pagination,
    goToPage,
  };
}
